
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import BreadcrumbNav from '@/components/breadcrumb-nav/breadcrumb-nav.vue'
import AbpBase from '@/lib/abpbase'
import cssStyle from '@/assets/styles/_variables.scss'

@Component({
  components: {
    BreadcrumbNav
  }
})
export default class LayoutHeader extends AbpBase {
  /**
   * 侧边菜单伸缩状态
   */
  @Prop({ type: Boolean, default: false }) collapse: boolean

  /**
   * 用户名
   */
  @Prop({ type: String, default: '' }) username: String

  // 2026-08-22 - Added by AI (CR-25-09) - show Change Store only for MultipleStore roles
  /**
   * 該使用者的 role 是否被設定為 MultipleStore。
   * 單門市使用者沒有可切換的對象，按鈕會是死路，故不顯示。
   */
  @Prop({ type: Boolean, default: false }) allowMultipleWorkingZone: boolean

  get cssStyle() {
    return cssStyle
  }

  /**
   * 侧边栏菜单点击
   */
  @Emit('toggle-sidebar')
  toggleSidebar() {}

  @Emit('on-click-user-dropdown')
  handleClickUserDropdown(command: String) {}

  /**
   * 面包屑菜单路径
   */
  get currentPath() {
    return this.$store.state.app.currentPath
  }
}
